import { render, staticRenderFns } from "./RoleDetails.vue?vue&type=template&id=823c4a20&"
import script from "./RoleDetails.vue?vue&type=script&lang=jsx&"
export * from "./RoleDetails.vue?vue&type=script&lang=jsx&"
import style0 from "./RoleDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports